/**
 * Takes an arbitrary image source and constructs a ViewerSource object from it which denotes a type and either an image url or a iiif info object
 */

export class SourceLoader {
	
	getSource(source) {

		if(!source) {
			return Promise.reject("Cannot load empty source");
		} else if(typeof source == "string") {
			//try parse as URL
			try {
				const url = new URL(source);
				return this.loadFromUrl(url);
			} catch (error) {
				try {
					const json = JSON.parse(source);
					return this.loadFromJson(source);
				} catch(error) {
					return Promise.reject("Cannot parse source as either URL or json");
				}
			}
		} else if(source instanceof URL) {
			return this.loadFromUrl(url);
		} else if(typeof source == 'object') {
			return this.loadFromJson(source);
		}
	}

	loadFromJson(json) {
		return Promise.resolve(new Source(undefined, 'application/json', json, this.getFirstString(json['@context']), this.getFirstString(json['profile'])));
	}

	getFirstString(value) {
		if(typeof value == "string") {
			return value;
		} else if(value instanceof Array && value.length > 0) {
			return this.getFirstString(value[0]);
		} else if(typeof value == "object") {
			return JSON.stringify(value);
		} else {
			return undefined;
		}
	}

	loadFromUrl(url) {

		return fetch(url, {
			method: "HEAD",
			redirect: "follow"
		})
		.then(response => {
			if(response.ok) {
				return response;
			} else {
				throw `Error loading data from ${url}. Status is ${response.status} ${response.statusText}`
			}
		})
		.then(response => response.headers)
		.then(headers => {
			if(headers.get('content-type')) {
				const content = headers.get('content-type').split(";");
				const mimetype = content[0];
				if(mimetype.startsWith('image')) {
					return new Source(url, mimetype);
				} else if(mimetype.match(/application\/(ld\+)?json/)) {
					//const iiifProfile = content.split(";").filter(s => s.match(/profile=.*iiif.io\/api\/image\/.*/)).map(s => s.substring(s.indexOf("=")+1)).map(x => x.replaceAll(/['\"]/g, "")).find(x => x); //does not always work
					return fetch(url, {
						method: "GET",
						redirect: "follow"
					})
					.then(response => response.json())
					.then(json => this.loadFromJson(json));
				} else {
					throw `Cannot load source ${url} with mimetype ${mimetype}`;
				}
			} else {
				throw `Cannot load source ${url} with unknown content-type`;
			}
		})
	}

	getMimetype(path) {
  		const ext = path.split('.').pop().toLowerCase();
		const mimeTypes = {
			'json': 'application/json',
			'js': 'application/javascript',
			'html': 'text/html',
			'css': 'text/css',
			'png': 'image/png',
			'jpg': 'image/jpeg',
			'jpeg': 'image/jpeg',
			'gif': 'image/gif',
			'svg': 'image/svg+xml',
			'txt': 'text/plain',
			'pdf': 'application/pdf',
			'csv': 'text/csv',
			'tif': 'image/tiff',
			'tiff': 'image/tiff',
			'jp2': 'image/jp2',
			'webp': 'image/webp'
		};

  		return mimeTypes[ext] || 'application/octet-stream'; // default fallback
	}

}

export class Source { 

	constructor(url, mimetype, json, context, profile) {
		this.mimetype = mimetype;
		if(url) {
			this.url = url;
			this.type = "image"
		} else if(json) {
			this.json = json;
			if(context == "http://iiif.io/api/image/2/context.json") {
				this.type = "iiif";
				this.version = "2";
			} else if(context == "http://iiif.io/api/image/3/context.json") {
				this.type = "iiif";
				this.version = "3";
			}
			if(profile.startsWith("http://iiif.io/api/image")) {
				this.level = profile.substring(profile.lastIndexOf("/")+1, profile.lastIndexOf("."));
			}
		}
	}
}

